/**
 * This file contains utility functions that can be used across the application.
 */

import { MAIN_SHELF_TYPES } from "../Variables";

/**
 * Truncate the title of a post to a specified length.
 * @param {*} title 
 * @param {*} maxLength 
 * @returns 
 */
export const truncateTitle = (title, maxLength = 50) => {
return title && title.length > maxLength
    ? `${title.substring(0, 47)}...`
    : title || 'Untitled'; // Fallback for undefined titles
};

export const isShelfMain = ({ shelfName, shelfId }) => {
    return MAIN_SHELF_TYPES.some(
        shelf =>
        (shelfName && shelf.name === shelfName) ||
        (shelfId && shelf.id === shelfId)
    );
};